import { snakeStore } from '@app/plugins/vuex-async-pagginate';
import { WebhookService } from '@autocaller_v2/services/WebhookService';

export const table = snakeStore(
  {
    actions: {
      getData: (_, params) => WebhookService.getList(params)
    }
  },
  true
);
